// src/entities/product/model/CategoryModel.ts
import { Expose } from 'class-transformer';

export class CategoryModel {
  @Expose({ name: 'category_id' })
  id: number;

  @Expose()
  name: string;
}
